import ChangePriceBlock from './ChangePriceBlock.vue';

export { ChangePriceBlock };
export default ChangePriceBlock;
